const STORAGE_PREFIX = 'voxel_trusted_device';

/** Opaque namespace segment for localStorage keys (not derived from Cognito config). */
const STORAGE_NAMESPACE = '7f3a9c2e1b8d4f06';

/** How long "Trust this device" skips OTP (same browser). */
export const TRUST_DEVICE_TTL_DAYS = 30;

const buildKey = (email) => {
  const normalizedEmail = (email || '').trim().toLowerCase();
  return `${STORAGE_PREFIX}_${STORAGE_NAMESPACE}_${normalizedEmail}`;
};

const readRecord = (email) => {
  const raw = localStorage.getItem(buildKey(email));
  if (!raw) return null;

  // Legacy format before TTL support
  if (raw === 'true') return null;

  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed?.exp !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
};

export const TrustedDeviceStorage = {
  isTrusted(email) {
    try {
      const record = readRecord(email);
      if (!record) return false;
      if (record.exp <= Date.now()) {
        this.clearTrusted(email);
        return false;
      }
      return true;
    } catch {
      return false;
    }
  },

  setTrusted(email) {
    try {
      const exp = Date.now() + TRUST_DEVICE_TTL_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem(buildKey(email), JSON.stringify({ exp }));
      return true;
    } catch {
      return false;
    }
  },

  clearTrusted(email) {
    try {
      localStorage.removeItem(buildKey(email));
    } catch {
      // ignore
    }
  },

  getExpiresAt(email) {
    const record = readRecord(email);
    return record?.exp ?? null;
  },

  clientMetadata(email) {
    if (!this.isTrusted(email)) {
      return { trustedDevice: 'false' };
    }
    const exp = this.getExpiresAt(email);
    return {
      trustedDevice: 'true',
      trustedExpiresAt: String(exp),
    };
  },
};

export default TrustedDeviceStorage;
